import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  NavigateNext as NavigateNextIcon,
} from '@mui/icons-material';

/**
 * Breadcrumb navigation for file browser pages.
 * @param {{ items: Array<{ label: string, path?: string }> }} props
 *   Last item should have no path (current page).
 */
const FileBreadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 2 }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        if (isLast || !item.path) {
          return (
            <Typography key={index} color="text.primary" variant="body2">
              {item.label}
            </Typography>
          );
        }
        return (
          <Link
            key={index}
            component="button"
            variant="body2"
            underline="hover"
            color="inherit"
            onClick={() => navigate(item.path)}
            sx={{ cursor: 'pointer' }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default FileBreadcrumb;
